import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModulePermission {
  [moduleName: string]: {
    create: boolean;
    read: boolean;
    update: boolean;
    delete: boolean;
    name: string;
  };
}

interface PermissionState {
  menus: ModulePermission;
}

const initialState: PermissionState = {
  menus: {},
};

const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setMenus(state, action: PayloadAction<ModulePermission>) {
      state.menus = action.payload;
    },
    clearMenus(state) {
      state.menus = {};
    },
  },
});

export const { setMenus, clearMenus } = permissionSlice.actions;
export default permissionSlice.reducer;
